import React, { Component } from 'react';
import {
    Alert, Badge, Button, Card, CardBody, CardHeader, Col, Input, Label, Row, Spinner, Table
} from 'reactstrap';

import { LiveSubscriptionAPI } from "api";
import { Utils } from "custom";

const moment = require("moment");

/**
 * LE LEZIONI LIVE DI QUESTO CLIENTE.
 *
 * ┌─ 🔴 PERCHE' QUESTA SCHEDA E' SEPARATA DALLE VENDITE ─────────────────────────────────┐
 * │                                                                                      │
 * │ Su CLTV il diritto sta in DUE posti, e non sono intercambiabili:                      │
 * │                                                                                      │
 * │   · i VIDEOCORSI e le CLASSI stanno in `sells` — una vendita per corso;               │
 * │   · le LEZIONI LIVE stanno in `live_subscriptions` — una riga per cliente, con        │
 * │     quante lezioni a settimana e fino a quando.                                            │
 * │                                                                                      │
 * │ Non e' un doppione da unificare: una vendita si compra una volta e resta, un          │
 * │ abbonamento live e' un rubinetto che si apre e si chiude e ha un contatore mensile.   │
 * │ Metterli nella stessa tabella vorrebbe dire dare a ogni vendita colonne che a         │
 * │ novantanove vendite su cento non servono.                                              │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ QUELLO CHE SI SCRIVE QUI NON ARRIVA AD ATOM. Normalmente l'abbonamento live nasce da
 * un incasso: ATOM annuncia `payment.confirmed`, il ponte legge la mappa dei prodotti e
 * apre il rubinetto. Da questa schermata si apre il rubinetto e basta — su ATOM non
 * risultera' nessun contratto e nessuno stara' incassando.
 *
 * 🔴 Serve per i clienti di PROVA e per i casi che il commerciale sistema a mano. Su un
 * cliente vero crea esattamente la situazione che l'integrazione esiste per evitare: uno
 * che studia gratis senza che nessuno se ne accorga. Per questo il riquadro giallo qui
 * sotto lo dice a schermo, e non solo in questo commento.
 */
class TabLive extends Component {

    constructor(props) {
        super(props);
        this.state = {
            caricando: true,
            errore: false,
            abbonamento: null,
            piani: [],
            /* Le quote che il server accetta davvero: servono a spiegare perche' un piano
               del catalogo puo' risultare spento. Vedi `listPlans` sul backend. */
            ammesse: [],
            salvando: false,
            // il modulo
            quota: "",
            dal: moment().format("YYYY-MM-DD"),
            al: ""
        };
    }

    componentDidMount() {
        this.carica();
    }

    /**
     * 🔴 QUI SERVE IL `clients.id`, NON L'`id` DELLA SCHEDA.
     *
     * `this.props.client.id` e' un `users.id`: la scheda cliente ha User come modello di
     * testa e ci fonde sopra i campi di Client. Tutte le rotte delle lezioni live vogliono
     * invece un `clients.id`, perche' `live_subscriptions.id_client` e' una chiave esterna
     * verso `clients`.
     *
     * ⚠️ NIENTE RIPIEGO SU `id` SE MANCA, ed e' il punto di tutta questa funzione. I due
     * contatori corrono nelle stesse fasce di numeri: mandare un `users.id` non da' un
     * errore, trova la riga di UN'ALTRA PERSONA e le regala il piano, con la schermata che
     * dice «Fatto». Meglio una scheda che si rifiuta di funzionare — si vede subito e non
     * fa danni a nessuno.
     */
    idCliente = () => {
        const id = this.props.client.id_client;
        return (typeof id === "number" && id > 0) ? id : null;
    };

    carica = () => {
        const idCliente = this.idCliente();

        if (idCliente === null) {
            this.setState({ caricando: false, errore: true });
            return;
        }

        this.setState({ caricando: true, errore: false });

        Promise.all([
            LiveSubscriptionAPI.plans(),
            LiveSubscriptionAPI.get(idCliente)
        ]).then(([catalogo, abbonamento]) => {
            const piani = catalogo.plans || [];

            this.setState({
                piani,
                ammesse: catalogo.allowed || [],
                abbonamento,
                caricando: false,
                /* Se ha gia' un piano il modulo parte da quello: chi apre la scheda quasi
                   sempre vuole prolungare o cambiare, non ricominciare da zero. */
                quota: abbonamento ? String(abbonamento.quota_per_period) : "",
                dal: abbonamento ? moment(abbonamento.valid_from).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD"),
                al: abbonamento ? moment(abbonamento.valid_until).format("YYYY-MM-DD") : ""
            });
        }).catch((e) => {
            console.error(e);
            this.setState({ caricando: false, errore: true });
        });
    };

    /**
     * Scegliere un piano riempie anche le date.
     *
     * ⚠️ La durata la porta il piano (`giorni`), non una costante di questa schermata: se
     * un giorno PREMIUM durasse 60 giorni invece di 30, qui cambia da solo.
     */
    scegliPiano = (piano) => {
        const dal = this.state.dal || moment().format("YYYY-MM-DD");

        this.setState({
            quota: String(piano.quota_per_period),
            /* `giorni - 1`: dal 1 al 30 settembre sono trenta giorni, non trentuno. */
            al: moment(dal).add(piano.giorni - 1, "days").format("YYYY-MM-DD")
        });
    };

    salva = () => {
        const { quota, dal, al } = this.state;
        const cliente = this.props.client;

        if (!quota || !dal || !al) {
            global.SweetAlert.fire({
                icon: 'warning',
                title: 'Manca qualcosa',
                text: 'Scegli il piano e le due date.',
                customClass: { confirmButton: 'btn btn-primary' }
            });
            return;
        }

        if (al < dal) {
            global.SweetAlert.fire({
                icon: 'warning',
                title: 'Le date sono invertite',
                text: 'La fine non puo\' venire prima dell\'inizio.',
                customClass: { confirmButton: 'btn btn-primary' }
            });
            return;
        }

        const nome = (this.state.piani.find((p) => String(p.quota_per_period) === String(quota)) || {}).nome
            || (quota + " lezioni a settimana");

        global.SweetAlert.fire({
            title: this.state.abbonamento ? 'Cambiare il piano?' : 'Attivare le lezioni live?',
            html: `<b>${nome}</b><br>dal ${moment(dal).format("DD/MM/YYYY")} al ${moment(al).format("DD/MM/YYYY")}`
                + `<br><br><small>Su ATOM non verrà registrato nessun contratto: nessuno starà incassando.</small>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sì, procedi',
            cancelButtonText: 'Annulla',
            customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-secondary ms-1' },
            buttonsStyling: false
        }).then((r) => {
            if (!r.value) return;

            this.setState({ salvando: true });

            LiveSubscriptionAPI.set({
                id_client: this.idCliente(),
                quota_per_period: Number(quota),
                valid_from: dal,
                valid_until: al
            }).then(() => {
                this.setState({ salvando: false });
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Fatto',
                    text: 'Il cliente può prenotare le lezioni live.',
                    customClass: { confirmButton: 'btn btn-success' }
                });
                this.carica();
            }).catch((e) => {
                console.error(e);
                this.setState({ salvando: false });
                global.SweetAlert.fire({
                    icon: 'error',
                    title: 'Non salvato',
                    /* Il server manda gia' un messaggio in chiaro quando rifiuta (per
                       esempio una quota fuori catalogo): si mostra quello, invece di
                       tradurre a mano una regola che vive dall'altra parte. */
                    text: this.motivoDelRifiuto(e, 'Non è stato possibile salvare il piano.'),
                    customClass: { confirmButton: 'btn btn-danger' }
                });
            });
        });
    };

    togli = () => {
        const cliente = this.props.client;

        global.SweetAlert.fire({
            title: 'Togliere le lezioni live?',
            html: 'Il cliente non potrà più prenotare.'
                + '<br><br><small>Le lezioni che ha <b>già</b> prenotato restano: quelle si disdicono una per una.</small>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sì, togli',
            cancelButtonText: 'Annulla',
            customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-outline-secondary ms-1' },
            buttonsStyling: false
        }).then((r) => {
            if (!r.value) return;

            LiveSubscriptionAPI.remove(this.idCliente()).then(() => {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Tolto',
                    customClass: { confirmButton: 'btn btn-success' }
                });
                this.carica();
            }).catch((e) => {
                console.error(e);
                global.SweetAlert.fire({
                    icon: 'error',
                    title: 'Non è stato possibile togliere il piano',
                    text: this.motivoDelRifiuto(e, ''),
                    customClass: { confirmButton: 'btn btn-danger' }
                });
            });
        });
    };

    /** Lo stato di adesso, detto come lo direbbe una persona. */
    statoCorrente = () => {
        const a = this.state.abbonamento;
        if (!a) return null;

        const oggi = moment().format("YYYY-MM-DD");
        const dal = moment(a.valid_from).format("YYYY-MM-DD");
        const al = moment(a.valid_until).format("YYYY-MM-DD");

        if (a.status !== "ACTIVE") return { colore: "secondary", testo: "sospeso" };
        if (al < oggi) return { colore: "danger", testo: "scaduto il " + moment(al).format("DD/MM/YYYY") };
        if (dal > oggi) return { colore: "info", testo: "parte il " + moment(dal).format("DD/MM/YYYY") };
        return { colore: "success", testo: "attivo fino al " + moment(al).format("DD/MM/YYYY") };
    };

    /* Il motivo di un rifiuto, detto a chi legge.

       ⚠️ `NO_PERMISSION` arriva SENZA `message` (lo manda `checkRole`, che risponde 401 e
       basta): senza questo caso qui usciva «Non e' stato possibile salvare il piano», che
       fa cercare un guasto dove c'e' invece una regola. Puo' arrivare anche a un
       amministratore — una sessione aperta ieri, il ruolo cambiato nel frattempo — quindi
       nascondere i tasti non basta: il messaggio serve lo stesso. */
    motivoDelRifiuto = (e, generico) => {
        if (e && e.status === "NO_PERMISSION")
            return "Il piano lo impostano gli amministratori e i consulenti. "
                + "Se il tuo ruolo e' cambiato da poco, esci e rientra.";
        return (e && e.message) || generico;
    };

    /* ┌─ 🔴 CHI VEDE NON E' CHI PUO' ────────────────────────────────────────────────────┐
       │ Questa schermata deve disegnare i tasti «Attiva» e «Togli» SOLO a chi il server   │
       │ lascerebbe passare. Quando non lo faceva, al consulente li mostrava come a tutti: │
       │ premendoli arrivava un 401 NO_PERMISSION SENZA nessun `message`, e usciva il      │
       │ rosso generico «Non e' stato possibile salvare il piano» — che non dice che non   │
       │ gli spetta, e manda a cercare un guasto che non c'e'.                             │
       │                                                                                  │
       │ 🔁 [7/09/2026] ADESSO PUO' ANCHE IL CONSULENTE, ma SOLO SUI PROPRI CLIENTI.       │
       │ `PUT /live/subscription` e `DELETE /live/subscription/:id_client` accettano ora   │
       │ ADMIN e CONSULENT, e il controller chiede in piu' «e' un tuo cliente?»            │
       │ (`live.controller.clienteAmmesso`). E' la regola identica dei videocorsi nella    │
       │ scheda accanto: chi vende il piano e' chi lo imposta, ai suoi.                    │
       │                                                                                  │
       │ 🔴 IL RUOLO DA SOLO NON BASTA, e fermarsi al ruolo qui sarebbe peggio di prima:   │
       │ al consulente si disegnerebbero i tasti su OGNI cliente, e su quelli dei colleghi │
       │ il server risponderebbe 401 — cioe' esattamente il rosso senza spiegazione che    │
       │ questo blocco esiste per evitare. Percio' si guarda anche di CHI e' il cliente.   │
       │                                                                                  │
       │ ⚠️ QUESTA E' UNA COPIA della regola del server, e le copie divergono. Non e' il   │
       │ permesso: e' solo la buona educazione di non offrire un gesto che verrebbe        │
       │ rifiutato. Chi cambia `clienteAmmesso` deve passare di qui — e se se ne dimentica,│
       │ `motivoDelRifiuto` qui sopra e' la rete: il 401 arriva lo stesso e viene spiegato,│
       │ invece di diventare un rosso senza motivo.                                        │
       │                                                                                  │
       │ ⚠️ `id_consulent_client` e' l'id dell'UTENTE consulente (`users.id`), lo stesso   │
       │ che il server confronta con `req.userId`. Confrontarlo con `client.id_client`     │
       │ sarebbe la trappola di sempre: due tabelle con righe negli stessi numeri.          │
       └──────────────────────────────────────────────────────────────────────────────────┘ */
    puoModificare = () => {
        const dati = Utils.getUserData();
        if (!dati) return false;

        if (dati.role === "ADMIN") return true;

        if (dati.role !== "CONSULENT") return false;

        const suo = this.props.client && this.props.client.id_consulent_client;
        return Boolean(suo) && Number(suo) === Number(dati.id);
    };

    render() {
        const { caricando, errore, abbonamento, piani, ammesse, salvando } = this.state;
        const puoModificare = this.puoModificare();

        if (caricando)
            return <div className="text-center p-5"><Spinner color="primary" /></div>;

        /* 🔴 Due guasti diversi, due frasi diverse. «Manca l'anagrafica cliente» si risolve
           in un modo (l'utente non e' un corsista, oppure il backend e' indietro di un
           rilascio e non manda ancora `id_client`); «non riesco a leggere» in un altro.
           Dare la stessa frase a tutti e due manda a cercare dalla parte sbagliata. */
        if (errore)
            return this.idCliente() === null
                ? <Alert color="danger">
                    Questa scheda non ha un'anagrafica cliente collegata, quindi le lezioni
                    live non si possono gestire da qui. Se l'utente <b>è</b> un corsista,
                    il backend non sta ancora mandando <code>id_client</code>: va rilasciato.
                </Alert>
                : <Alert color="danger">Non è stato possibile leggere i dati delle lezioni live.</Alert>;

        const stato = this.statoCorrente();
        const spenti = piani.filter((p) => !p.abilitato);

        return (
            <React.Fragment>

                {/* 🔴 Sta a schermo e non solo nei commenti: chi usa questa schermata deve
                    sapere che sta aprendo un rubinetto senza che nessuno incassi. */}
                <Alert color="warning" className="d-flex align-items-start">
                    <i className="ri-alert-line fs-20 me-2"></i>
                    <div>
                        <b>Questo non passa da ATOM.</b> Normalmente l'abbonamento live nasce da un
                        incasso registrato su ATOM. Quello che imposti qui apre l'accesso e basta:
                        su ATOM non risulterà nessun contratto e nessuno starà incassando.
                        <br />
                        <small>Da usare per i clienti di prova e per i casi sistemati a mano.</small>
                    </div>
                </Alert>

                <Row>
                    <Col lg={5}>
                        <Card>
                            <CardHeader><h6 className="mb-0">Adesso</h6></CardHeader>
                            <CardBody>
                                {(!abbonamento) ? (
                                    <div className="text-muted">
                                        <i className="ri-close-circle-line me-1"></i>
                                        Nessun piano live: questo cliente non può prenotare.
                                    </div>
                                ) : (
                                    <Table className="table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted" style={{ width: 130 }}>Piano</td>
                                                <td><b>{abbonamento.quota_per_period} lezioni a settimana</b></td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Stato</td>
                                                <td><Badge color={stato.colore}>{stato.testo}</Badge></td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Validità</td>
                                                <td>
                                                    dal {moment(abbonamento.valid_from).format("DD/MM/YYYY")}
                                                    {" al "}{moment(abbonamento.valid_until).format("DD/MM/YYYY")}
                                                </td>
                                            </tr>
                                            {/* ⚠️ Il cambio piano in attesa si mostra solo se c'e': altrimenti al
                                                rinnovo la quota cambierebbe da sola e nessuno saprebbe perche'. */}
                                            {(abbonamento.pending_quota_per_period) ? (
                                                <tr>
                                                    <td className="text-muted">Dal rinnovo</td>
                                                    <td className="text-warning">
                                                        <b>{abbonamento.pending_quota_per_period} lezioni a settimana</b>
                                                        <br /><small>cambio piano chiesto dal cliente sul portale</small>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </Table>
                                )}
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg={7}>
                        <Card>
                            <CardHeader>
                                <h6 className="mb-0">
                                    {puoModificare ? (abbonamento ? "Cambia" : "Attiva") : "Chi lo cambia"}
                                </h6>
                            </CardHeader>
                            <CardBody>

                            {(!puoModificare) ? (
                                <div className="text-muted">
                                    <i className="ri-lock-line me-1"></i>
                                    {/* 🔴 DUE MOTIVI DIVERSI, DUE FRASI DIVERSE. «Non e' il tuo
                                        cliente» si risolve chiamando un collega; «non hai il
                                        ruolo» si risolve chiamando un amministratore. Una frase
                                        sola per tutti e due manderebbe meta' delle persone dalla
                                        parte sbagliata. */}
                                    {(Utils.getUserData() || {}).role === "CONSULENT" ? (
                                        <React.Fragment>
                                            Questo cliente e' seguito da{" "}
                                            <b>
                                                {this.props.client && this.props.client.consulent
                                                    ? this.props.client.consulent.firstname + " "
                                                      + this.props.client.consulent.lastname
                                                    : "un altro consulente"}
                                            </b>
                                            : il piano lo imposta chi lo segue. Da qui puoi vederlo.
                                            <br />
                                            <small>
                                                Se il cliente e' passato a te da poco, fallo
                                                riassegnare nella scheda anagrafica: il permesso
                                                segue quell'assegnazione.
                                            </small>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            Il piano lo impostano gli <b>amministratori</b> e il{" "}
                                            <b>consulente che segue il cliente</b>: da qui puoi
                                            vederlo, non cambiarlo.
                                            <br />
                                            <small>
                                                Se il tuo ruolo e' cambiato da poco, esci e rientra:
                                                il permesso si legge dalla sessione, e la tua e' di
                                                prima.
                                            </small>
                                        </React.Fragment>
                                    )}
                                </div>
                            ) : (<React.Fragment>

                                <Label>Piano</Label>
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                    {piani.filter((p) => p.abilitato).map((p) => (
                                        <Button
                                            key={p.quota_per_period}
                                            color={String(this.state.quota) === String(p.quota_per_period) ? "primary" : "light"}
                                            onClick={() => this.scegliPiano(p)}
                                            type="button">
                                            {p.nome}
                                        </Button>
                                    ))}
                                </div>

                                {/* 🔴 IL CATALOGO VUOTO SI DICE, PRIMA TACEVA.
                                    Senza nessun piano mappato, sotto «Piano» non compariva NIENTE: né un
                                    pulsante né una frase. Chi apriva la scheda non aveva niente da
                                    cliccare e nessun modo di sapere perché — e la segnalazione che
                                    arrivava era «imposto il piano e le lezioni live non si abilitano»,
                                    che manda a cercare dalla parte sbagliata.
                                    ⚠️ E NON È UNA MANCANZA DI QUESTA SCHERMATA: `atom_product_map` non ha
                                    nessuna interfaccia da nessuna parte, quindi questo è l'unico posto
                                    dove la cosa può essere detta a chi la sta subendo. */}
                                {(piani.length === 0) ? (
                                    <Alert color="warning" className="py-2 fs-13">
                                        <b>Nessun piano configurato.</b> Le lezioni live non si possono
                                        attivare per nessun cliente finché i piani non sono collegati ai
                                        prodotti di ATOM: quella corrispondenza non ha una schermata, si
                                        scrive con <code>prove/configura-piani-live.js</code> sul backend.
                                        <br />
                                        <small className="text-muted">
                                            Non è un guasto di questo cliente: riguarda tutto l'ambiente.
                                        </small>
                                    </Alert>
                                ) : null}

                                {/* Un piano del catalogo che il server rifiuterebbe si dice, invece di
                                    offrire un pulsante che darebbe errore al salvataggio. */}
                                {(spenti.length > 0) ? (
                                    <Alert color="light" className="py-2 fs-13">
                                        <b>{spenti.map((p) => p.nome).join(", ")}</b> è nel catalogo ma il
                                        server accetta solo {ammesse.join(" o ")} lezioni a settimana.
                                        Va allineata la costante <code>PIANI_AL_MESE</code>.
                                    </Alert>
                                ) : null}

                                <Row>
                                    <Col md={6}>
                                        <Label htmlFor="live-dal">Dal</Label>
                                        <Input id="live-dal" type="date" value={this.state.dal}
                                            onChange={(e) => this.setState({ dal: e.target.value })} />
                                    </Col>
                                    <Col md={6}>
                                        <Label htmlFor="live-al">Al</Label>
                                        <Input id="live-al" type="date" value={this.state.al}
                                            onChange={(e) => this.setState({ al: e.target.value })} />
                                    </Col>
                                </Row>

                                <div className="d-flex gap-2 mt-3">
                                    <Button color="primary" onClick={this.salva} disabled={salvando}>
                                        {salvando ? <Spinner size="sm" /> : <i className="ri-check-line me-1"></i>}
                                        {" "}{abbonamento ? "Salva" : "Attiva"}
                                    </Button>

                                    {(abbonamento) ? (
                                        <Button color="danger" outline onClick={this.togli} disabled={salvando}>
                                            <i className="ri-delete-bin-line me-1"></i> Togli
                                        </Button>
                                    ) : null}
                                </div>
                            </React.Fragment>)}

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default TabLive;
